import { RentalObject } from './rental-object';
import { FormOfLease, RentalObjectCategory } from './const/enums';
import { RentalObjectKey } from './rental-object-key';
import { BrfSpecifics } from './brf-specifics';
import { RentalObjectConsumptionMeter } from '../../consumption/model/rentalobject-consumption-meter';
import { ModelBase } from '../../core/model/model-base';
import { PostTargetModel } from '../service/base/post-target-loader.interface';

export class Parking extends RentalObject {
  constructor() {
    super();
    this.category = RentalObjectCategory.Parking;
    this.indvidualMeterElectricity = false;
  }

  keys: RentalObjectKey[];
  allowedFormsOfLease: FormOfLease[];
  indvidualMeterElectricity: boolean;
  imdMeterElectricity: RentalObjectConsumptionMeter;
  imdMeterChargingElectricity: RentalObjectConsumptionMeter;
  parkingNumber: number;
  isGarage: boolean;
  parkingHasElectricity: boolean;
  parkingHasRoof: boolean;
  brfSpecifics: BrfSpecifics;
  changedAt: Date;
}

export class ParkingPostTarget extends ModelBase implements PostTargetModel {
  constructor(dataContext?: ParkingPostTarget) {
    super();
    if (dataContext) {
      this.id = dataContext.id || '';
      this.propertyNumberName = dataContext.propertyNumberName || '';
      this.companyNumberName = dataContext.companyNumberName || '';
      this.parkingNumberName = dataContext.parkingNumberName || '';
    }
  }

  companyNumberName: string;
  propertyNumberName: string;
  parkingNumberName: string;

  postTargetDescription() {
    return {
      key: 'POST.POST_TARGET_DESCRIPTION.PARKING',
      params: { companyName: this.companyNumberName, propertyName: this.propertyNumberName, parkingName: this.parkingNumberName },
    };
  }

  toAutocompleteValue(viewType: 'list' | 'field', culture?: string): string {
    switch (viewType) {
      case 'field':
      case 'list':
        return this.parkingNumberName;
    }
  }

  toString(culture?: string): string {
    return this.parkingNumberName;
  }
}
